import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CanActivate } from '@spartacus/storefront/cms-structure/services/guards-composer';
import { WholesalerPharmacyService } from '../services';
import {
  combineLatest,
  first,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
} from 'rxjs';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { UserUtils } from 'src/app/shared';
import { WholesalerPharmacySelectorComponent } from '../components';

@Injectable({
  providedIn: 'root',
})
export class WholesalerPharmacyGuard implements CanActivate {
  constructor(
    protected modalService: NgbModal,
    protected wholesalerPharmacyService: WholesalerPharmacyService,
    protected user: UserAccountFacade
  ) {}
  modalSubscription = new Subscription();
  isDirectUser$ = this.user.get().pipe(map(UserUtils.isDirectUser));
  canActivate(): Observable<boolean> {
    return this.handleNonDefaultWholesaler();
  }

  handleNonDefaultWholesaler(): Observable<boolean> {
    return combineLatest([
      this.wholesalerPharmacyService.getDefaultWholesalerPharmacy(),
      this.isDirectUser$,
    ]).pipe(
      switchMap(([defaultId, isDirectUser]) => {
        if (!defaultId && !isDirectUser) {
          const modal = this.modalService.open(
            WholesalerPharmacySelectorComponent
          );
          return modal.dismissed.pipe(
            first(),
            map((reason) => {
              return reason === 'confirm';
            })
          );
        } else {
          return of(true);
        }
      })
    );
  }
}
